import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { useClient } from './ClientContext';
export function Hero() {
  const {
    clientName,
    companyName
  } = useClient();
  const firstName = clientName.split(' ')[0] || 'Rakesh';
  return <section className="pt-24 pb-0 bg-offwhite" data-id="element-40">
      {/* Red hero intro - high impact */}
      <div className="bg-[#DC2626] px-6 py-16 md:py-20" data-id="element-41">
        <div className="max-w-7xl mx-auto" data-id="element-42">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-43">
            <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-8" data-id="element-44">
              <span className="text-white/90" data-id="element-45">Hi {firstName},</span>
            </h1>
            <div className="max-w-2xl space-y-4 text-white/85" data-id="element-46">
              <p className="text-lg leading-relaxed" data-id="element-47">
                Thank you for the opportunity to share this proposal. It
                outlines a focused approach to building a Minimum Viable Brand
                Identity designed to create clarity and support future growth.
              </p>
              <p className="text-lg leading-relaxed" data-id="element-48">
                Happy to walk through the thinking or answer any questions as
                you review.
              </p>
              <div className="pt-6" data-id="element-49">
                <p className="text-lg text-white/70" data-id="element-50">Best,</p>
                <p className="text-2xl font-bold text-white mt-2" data-id="element-51">Avy Pruthi</p>
                {/* Signature squiggle */}
                <div className="mt-4" data-id="element-52">
                  <svg width="120" height="50" viewBox="0 0 120 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-80" data-id="element-53">
                    <motion.path d="M5 38C8 28 12 15 18 12C24 9 22 30 26 28C30 26 32 10 38 14C44 18 40 35 46 32C52 29 56 8 62 12C68 16 64 34 70 30C76 26 82 10 86 16C90 22 88 38 94 34C100 30 104 18 108 22C112 26 115 35 115 35" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.7
                  }} transition={{
                    duration: 1.5,
                    delay: 0.8,
                    ease: 'easeInOut'
                  }} data-id="element-54" />
                  </svg>
                </div>
                <p className="text-sm text-white/50 uppercase tracking-wider mt-2" data-id="element-55">
                  Founder & Director
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Project Info */}
      <div className="px-6" data-id="element-56">
        <motion.div className="max-w-7xl mx-auto border-b border-gray-200 py-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-57">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-58">
            <div data-id="element-59">
              <div className="flex items-start gap-2 mb-2" data-id="element-60">
                <h2 className="text-2xl md:text-3xl font-bold text-navy leading-snug" data-id="element-61">
                  Brand identity design
                  <br data-id="element-62" />
                  project (MVB)
                </h2>
                <div className="relative group mt-2" data-id="element-63">
                  <InfoIcon className="w-5 h-5 text-gray-400 cursor-help" data-id="element-64" />
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-40 bg-navy text-white text-xs p-2 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-20 text-center" data-id="element-65">
                    Minimum Viable Brand
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-sm" data-id="element-66">
              <div data-id="element-67">
                <span className="block text-gray-400 text-xs tracking-wider mb-1" data-id="element-68">
                  Client
                </span>
                <span className="font-semibold text-navy" data-id="element-69">{clientName}</span>
                <span className="block text-gray-400 text-xs mt-0.5" data-id="element-70">
                  {companyName}
                </span>
              </div>
              <div data-id="element-71">
                <span className="block text-gray-400 text-xs tracking-wider mb-1" data-id="element-72">
                  Agency
                </span>
                <span className="font-semibold text-navy" data-id="element-73">
                  AVY Consultancy Ltd
                </span>
              </div>
              <div data-id="element-74">
                <span className="block text-gray-400 text-xs tracking-wider mb-1" data-id="element-75">
                  Date
                </span>
                <span className="font-semibold text-navy" data-id="element-76">07.02.26</span>
              </div>
              <div data-id="element-77">
                <span className="block text-gray-400 text-xs tracking-wider mb-1" data-id="element-78">
                  Valid until
                </span>
                <span className="font-semibold text-navy" data-id="element-79">12.02.26</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}